<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header justify-content-center">
    <div class="modal-title">Are you sure?</div>
  </div>
  <div class="modal-body">
    <div class="red-text text-center">This Action is Irreversible.</div>
    <div>This will result in following:</div>
    <ol>
      <li>No more bids will be allowed.</li>
      <li>Winners will be notified and items will be added to their cart.</li>
    </ol>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-4 offset-2">
        <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" (click)="close(dialog, false)">Cancel</button>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn--paybee btn--success btn--md text-center w-100" (click)="close(dialog, true)">Confirm</button>
      </div>
    </div>
  </div>
</ng-container>
